// extracted by mini-css-extract-plugin
export default {"headerBar":"ImportHospitalStaff_headerBar__6CVMW"};